/**
 * @generated SignedSource<<1246877e65fc74c6fa03f72d3297c951>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView$data = {
  readonly dateTime: AGG$DateTime | null | undefined;
  readonly id?: string;
  readonly " $fragmentType": "dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView";
};
export type dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView$key = {
  readonly " $data"?: dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "dateTime"
    }
  ],
  "type": "JiraDateTimePickerField"
};

(node as any).hash = "0df740d2008e12f8a9d53fbd1dbcb30e";

export default node;
